import type {
  LeafletMouseEvent,
  LeafletMouseEventHandlerFn,
  Map
} from 'leaflet';
import { latLngBounds, point } from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import { useActions, useAppState } from '@/overmind';

export function useFindFeaturesOnMapClick() {
  const map = useMap();
  const layerIdsToSearch =
    useAppState().arcgis.config.matches('LOADED')?.value.mapSource.layerIds;

  const { getFeaturesInBounds, resetFeaturesInBoundsState } =
    useActions().arcgis.featuresInBounds;

  useEffect(() => {
    let clickHandler: LeafletMouseEventHandlerFn | undefined;
    if (map && layerIdsToSearch) {
      clickHandler = clickEvent => {
        const bounds = getSearchBounds(clickEvent, map);
        getFeaturesInBounds({ bounds, layerIdsToSearch });
      };
      map?.addEventListener('click', clickHandler);
    }
    return () => {
      if (map && clickHandler) {
        map.removeEventListener('click', clickHandler);
      }
    };
  }, [map, layerIdsToSearch, getFeaturesInBounds]);

  return [resetFeaturesInBoundsState];
}

function getSearchBounds(clickEvent: LeafletMouseEvent, map: Map) {
  const { x, y } = clickEvent.layerPoint;
  const errorMarginInPixels = 10;
  const southWest = map.layerPointToLatLng(
    point(x - errorMarginInPixels, y - errorMarginInPixels)
  );
  const northEast = map.layerPointToLatLng(
    point(x + errorMarginInPixels, y + errorMarginInPixels)
  );
  return latLngBounds(southWest, northEast);
}
